module.exports = __webpack_public_path__ + "img/IMG_9543_L.ed06d38a.webp";